import React from 'react';
import { SunOutlined, MoonFilled } from '@ant-design/icons';
import { useTheme } from '../../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

export const ThemeSelector: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <button
      onClick={toggleTheme}
      className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-dark-bg transition-colors"
      title={theme === 'dark' ? t('settings.light') : t('settings.dark')}
    >
      {theme === 'dark' ? (
        <MoonFilled className="text-lg text-yellow-400" />
      ) : (
        <SunOutlined className="text-lg text-yellow-500" />
      )}
    </button>
  );
};
